import axios from '../../../../axiosRetailReleases';

const currentURL = window.location.href;
const url = new URL(currentURL);
const domain = url.origin;

// danh sach
const getListResource = (data, header) => {
    const { status, ...arg } = data;
    return axios({
        url: '/client-resource/list',
        method: 'POST',
        data: {
            ...arg,
            status: Array.isArray(status) ? status : status === -1 || status === null ? [] : [status],
            link: '/resource-management',
            domain: domain,
        },
        headers: header,
    });
};

export { getListResource };
